export default {"src":"/_next/static/media/chevron.3c97053b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};